/**
 * Update Work Spec agent seeds are stored as a machine prompt (intent tags,
 * write-allowlist UUIDs, ingest preflight JSON, untrusted comment wrappers).
 * Chat UI should show a short summary - not that dump.
 */

const SEED_PREFIX_RE = /^\s*\[update_work_spec\]/i
const TODO_URL_RE =
  /https?:\/\/(?:app\.)?(?:3\.)?basecamp\.com\/[^\s)>\]]+/i
const TODO_ID_FROM_URL_RE = /\/todos\/(\d+)/i

export type UpdateWorkSpecSeedSummary = {
  todoUrl: string | null
  todoId: string | null
  filePath: string | null
  fileName: string | null
}

export function isUpdateWorkSpecSeedPrompt(content: string | undefined | null): boolean {
  if (!content) return false
  return SEED_PREFIX_RE.test(content)
}

function labeledValue(content: string, label: RegExp): string | null {
  const match = content.match(label)
  const value = match?.[1]?.trim()
  return value ? value : null
}

function fileNameFromPath(filePath: string | null): string | null {
  if (!filePath) return null
  const cleaned = filePath.replace(/\/+$/, '')
  const base = cleaned.split('/').pop() || cleaned
  return base.replace(/\.md$/i, '') || null
}

export function parseUpdateWorkSpecSeedPrompt(
  content: string | undefined | null,
): UpdateWorkSpecSeedSummary | null {
  if (!isUpdateWorkSpecSeedPrompt(content)) return null
  const text = content as string

  const labeledUrl = labeledValue(
    text,
    /\*\*Basecamp todo URL:\*\*\s+(\S+)/i,
  )
  const urlMatch = labeledUrl || text.match(TODO_URL_RE)?.[0] || null
  const todoUrl = urlMatch ? urlMatch.replace(/[.,;]+$/, '') : null

  const labeledTodoId = labeledValue(text, /\*\*Todo id:\*\*\s+(\d+)/i)
  const todoId =
    labeledTodoId || (todoUrl ? todoUrl.match(TODO_ID_FROM_URL_RE)?.[1] ?? null : null)

  const filePath = labeledValue(text, /\*\*Work spec path:\*\*\s+(\S+)/i)
  const fileName = fileNameFromPath(filePath)

  return { todoUrl, todoId, filePath, fileName }
}
